import React, { PureComponent } from "react";
import PinIcon from "./PinIcon";
import ToothpasteTag from "../ToothpasteTag";
import * as colors from "../../helpers/constants/colors";

class SegmentedBarItem extends PureComponent {
    renderPin = (label, pageId, color, isBaseline, isWinner, isSelected) => {
        let strokeColor = color === "auto" ? "#bbbbbb" : color;
        let unselectedFillColor = colors.white;
        return (
            <div className="BarSegment_item_marker">
                <div
                    style={{
                        color: isSelected ? unselectedFillColor : strokeColor
                    }}
                    className="BarSegment_item_marker_label"
                >
                    {label}
                </div>
                <div
                    className="BarSegment_item_marker_pin"
                    style={{ position: "absolute" }}
                >
                    <PinIcon
                        height="40"
                        fill={isSelected ? strokeColor : unselectedFillColor}
                        stroke={strokeColor}
                    />
                </div>
            </div>
        );
    };

    renderFlag = (page, isWinner) => {
        const flags = [];
        const { isBaseline } = page;
        const flag = (key, label, color) => (
            <ToothpasteTag
                key={key}
                color={color ? color : "transparent"}
                label={label ? label : "-"}
                style={{
                    width: "100%",
                    margin: "2px 0px",
                    opacity: color && label ? 1 : 0
                }}
            />
        );
        if (isBaseline) {
            flags.push(
                flag(
                    `baseline-flag-${page.id}`,
                    "BASELINE",
                    colors.baselineColor
                )
            );
        }
        if (isWinner) {
            flags.push(
                flag(`winner-flag-${page.id}`, "WINNER", colors.winnerColor)
            );
        }
        while (flags.length < 2) {
            flags.push(flag(`blank-flag-${page.id}-${flags.length}`));
        }
        return <div className="BarSegment_item_flags">{flags}</div>;
    };

    render() {
        const { page, isSelected, isWinner } = this.props;

        return (
            <div
                className="BarSegment_item"
                style={{
                    transform: `translateY(-50%) translateX(${
                        this.props.position
                    }px)`,
                    top: "110px",
                    zIndex: isSelected ? 6 : 5
                }}
            >
                {this.renderPin(
                    page.pageLabel,
                    page.id,
                    page.color,
                    page.isBaseline,
                    isWinner,
                    isSelected
                )}
                <div className="BarSegment_item_icon_box">
                    {page.isBaseline || isWinner ? (
                        <div
                            className="BarSegment_item_icon"
                            style={{
                                height: "30px",
                                width: "1px",
                                zIndex: 4,
                                color: colors.typography,
                                backgroundColor: colors.black
                            }}
                        >
                            |
                        </div>
                    ) : (
                        ""
                    )}
                    {page.isCompetitor ? (
                        <div
                            className="BarSegment_item_icon"
                            style={{
                                height: "15px",
                                width: "15px",
                                zIndex: 5,
                                color: colors.white,
                                backgroundColor: colors.competitorColor
                            }}
                        >
                            C
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {this.renderFlag(page, isWinner)}
            </div>
        );
    }
}

export default SegmentedBarItem;



// WEBPACK FOOTER //
// ./src/components/SegmentedBar/SegmentedBarItem.js